import { CastBar, PlayerFrame, TargetFrame } from './Frames';
import { Chat } from './Chat';
import { Hotbar } from './Hotbar';
import { InventoryWindow } from './InventoryWindow';
import { MinimapPanel } from './MinimapPanel';
import {
  AreaBanner,
  ConnectionBanner,
  DeathOverlay,
  FpsCounter,
  InteractHint,
  KickOverlay,
  LoadingVeil,
  Toasts,
} from './Misc';
import { QuestTracker } from './QuestTracker';
import { TouchControls } from './TouchControls';
import {
  CharacterWindow,
  DialogWindow,
  HelpWindow,
  MapWindow,
  MenuWindow,
  QuestWindow,
  ShopWindow,
  WaypointWindow,
} from './Windows';

export function Hud({ onLeave }: { onLeave: () => void }) {
  return (
    <div className="hud">
      <PlayerFrame />
      <TargetFrame />
      <MinimapPanel />
      <QuestTracker />
      <FpsCounter />
      <Toasts />
      <AreaBanner />
      <CastBar />
      <InteractHint />
      <Hotbar />
      <Chat />
      <TouchControls />
      <InventoryWindow />
      <CharacterWindow />
      <QuestWindow />
      <DialogWindow />
      <ShopWindow />
      <WaypointWindow />
      <MapWindow />
      <HelpWindow />
      <MenuWindow onLeave={onLeave} />
      <ConnectionBanner />
      <DeathOverlay />
      <KickOverlay onLeave={onLeave} />
      <LoadingVeil />
    </div>
  );
}
